export const hyphenatedCities = [
  'shi-yomi',
  'didwana-kuchaman',
  'sarangarh-bilaigarh',
  'kotputli-behror',
  'khairthal-tijara',
]

export const AMETHI = 'amethi-csm-nagar'
export const AMETHI_SLASH = 'amethi/csm nagar'

export const slugArrayFuel = [
  'fuel-price',
  'petrol-price',
  'diesel-price',
  'petrol-price-in-amethi-csm-nagar',
  'diesel-price-in-amethi-csm-nagar',
  'petrol-price-in-bilaspur-358089',
  'diesel-price-in-bilaspur-358089',
  'petrol-price-in-hamirpur-355340',
  'diesel-price-in-hamirpur-355340',
]

export const commonCities = [
  {
    bilaspur: {
      otherStates: 'Chhatisgarh',
      preferredState: 'Himachal Pradesh',
    },
  },
  {
    hamirpur: {
      otherStates: 'Himachal Pradesh',
      preferredState: 'Uttar Pradesh',
    },
  },
]
